import { useState } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'

export default function Faq({}: RouteComponentProps) {
  const [showIndex, setShowIndex] = useState(0)
  return (
    <section className="faq-sec h-100 mt-5">
      <div className="container">
        <div className="accordion">
          <div className="image-box">
            <img src="img/faq-img.png" alt="" />
          </div>
          <div className="accordion-text">
            <div className="title">Frequently Asked Questions</div>
            <ul className="faq-text">
              <li onClick={() => setShowIndex(showIndex == 1 ? 0 : 1)}>
                <div className="question-arrow">
                  <span className="question">How do I mint my MIC NFT?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 1 && (
                  <span style={{ color: 'white' }}>
                    Only MIC WL Token holders will be able to mint a MIC Meta Cloak NFT.
                  </span>
                )}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 2 ? 0 : 2)}>
                <div className="question-arrow">
                  <span className="question">What wallet do I use?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 2 && <span style={{ color: 'white' }}>Metamask or Trustwallet</span>}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 3 ? 0 : 3)}>
                <div className="question-arrow">
                  <span className="question">What network?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 3 && <span style={{ color: 'white' }}>Ethereum</span>}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 4 ? 0 : 4)}>
                <div className="question-arrow">
                  <span className="question">How does MIC work?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 4 && (
                  <span style={{ color: 'white' }}>
                    Meta Invisible Cloak only works after holding both blue and red secret mineral crystals in your
                    wallet with the MIC NFT. You can receive both crystals by connecting your MetaMask to{' '}
                    <Link to="/">https://metainvisiblecloak.com/</Link> and sharing your affiliate link with 2 friends.
                  </span>
                )}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 5 ? 0 : 5)}>
                <div className="question-arrow">
                  <span className="question">What’s a MIC WL Mint Token?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 5 && (
                  <span style={{ color: 'white' }}>
                    MIC WL Mink Token is a token that will be used to redeem for your MIC NFT on our website
                    <Link to="/">https://metainvisiblecloak.com/</Link>
                  </span>
                )}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 6 ? 0 : 6)}>
                <div className="question-arrow">
                  <span className="question">How do I mint the MIC Secret mineral crystals?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 6 && (
                  <span style={{ color: 'white' }}>
                    MIC Secret Mineral Crystal’s can only be received by referring two friends with your special
                    referral code to get a MIC WL token. All unclaimed Mineral Crystals will be availble on Opensea at a
                    starting floor price of 1 ETH.
                  </span>
                )}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 7 ? 0 : 7)}>
                <div className="question-arrow">
                  <span className="question">When can I mint my MIC NFT?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 7 && (
                  <span style={{ color: 'white' }}>
                    When can I mint my MIC NFT? MIC NFT’s will be availble for mint soon only too MIC WL Token holders.
                    Date pending all announcements will come only from our official twitter page or{' '}
                    <Link to="/">https://metainvisiblecloak.com/</Link>
                  </span>
                )}
                <span className="line" />
              </li>
              <li onClick={() => setShowIndex(showIndex == 8 ? 0 : 8)}>
                <div className="question-arrow">
                  <span className="question">How many MIC WL Tokens can I have?</span>
                  <i className="bx bxs-chevron-down arrow" />
                </div>
                {showIndex == 8 && <span style={{ color: 'white' }}>1 MIC WL Token per wallet. Don’t be greedy!</span>}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
